import { internal, template } from '../../../vendor/elix.js';
import FloatingLabelBaseMixin from './floating-label-base-mixin.js';

function FloatingLabelForOutlinedInputMixin(Base) {
  
  return class FloatingLabelForOutlinedInput extends FloatingLabelBaseMixin(Base) {

    get [internal.template]() {

      return template.concat(

        super[internal.template],

        template.html`

        <style>

          label {
            left: 16px;
            top: 19px;
          }

          label.floating {
            background-color: var(--tp-floating-label-outlined-mixin-background-color-floating);
            left: 12px;
            top: -8px;
          }

          .inputStateContainer.with-leading-slot-contents label:not(.floating) {
            margin-left: 32px;
          }

        </style>
        
        `
      );

    }

  }
}

export default FloatingLabelForOutlinedInputMixin;
